import * as React from "react";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import  {MSG_VISIO} from "../MessagesVisio.js"
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import { type, userInfo } from "os";

export type type_home = {
value:undefined,
isValidSignin:undefined,
isValidLogin:undefined
}

export default class CardOpenVisio extends React.Component  <HomeProps> {
  msg_visio=MSG_VISIO;
  state = {
    name: '',
    teacheractif:false,
    teacherid:''
  }  
  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    console.log(this.props);
    this.handleUpdateName();
    if(this.props.teacherid!="")this.setState({teacheractif:false});
    else this.setState({teacheractif:true});
    this.setState({teacherid:this.props.teacherid});
    
   
    
  }
 
  componentDidUpdate(prevProps, prevState) {
    if (prevState.name !== prevProps.usernickname.nickname) {
      this.handleUpdateName();
    }
    console.log(this.props.teacherid);
   /* if(prevState.teacherid!=prevProps.teacherid)
    {
      this.setState({teacherid:prevProps.teacherid});
      if(prevProps.teacherid!="")this.setState({teacheractif:false});
      else this.setState({teacheractif:true});
    }*/
    if(this.props.teacherid!=this.state.teacherid)
    {
      this.setState({teacherid:this.props.teacherid});
      if(this.props.teacherid!="")this.setState({teacheractif:false});
      else this.setState({teacheractif:true});
    }
  }
  handleUpdateName = () => {
    this.setState({ name: this.props.usernickname.nickname });
    const item=document.getElementById('id_name');
    item.value=this.props.usernickname.nickname;
  }
   render() {
    
    const {isnotlabo,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;

    return(
     <div>
     
     <span style={{display:isnotlabo}}>
     <Card style={{width:260,margin:4}} interactive={true} elevation={Elevation.TWO}>
     <h3><a href="">Visio Conférence</a></h3>
     <p><b>Accéder à la visio conférence</b></p><p>En appuyant sur le bouton ci-dessous, vous pourrez accéder à la visio conférence de votre classe.</p>
     <p></p>
     <Button onClick={(ev)=>handleOpenVisio(this.msg_visio.OUVRIR_VISIO,"")} disabled={this.state.teacheractif}>Accéder à la visio</Button>
     <Button style={{marginTop:8}} onClick={(ev)=>handleOpenVisio(this.msg_visio.SET_TEACHER_CONNECTED,"")} >Choisir un enseignant</Button>
     <p style={{marginTop:10}}>Vous pouvez changer le nom utilisé pour la visio ci-dessous</p>
     <input id='id_name' type='text' onChange={(e)=>{var st=e.target.value; if(st=="")this.handleUpdateName(); localStorage.setItem("nickname",st);}}></input>
     </Card>
     </span>
     
     </div>);
}
}
